import React, { useState, useEffect } from 'react';
import './RefundPolicy.css';
import NAVBAR from '../../Components/Navbar/NewNavbar';
import Footer from '../../Components/Footer/Footer';
import Loading1 from '../../Components/Loading/Loading1';

function RefundPolicy() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <NAVBAR />
            <div className="refund-container">
                <h2 className="refund-title">Refund Policy</h2>
                <p className="refund-text">
                    Welcome to <strong>ASTRACLEAN TECHNOLOGIES PVT LTD.</strong> Customer satisfaction is our top priority, 
                    and we are committed to providing high-quality services. To maintain transparency, we would 
                    like to clarify our refund policy:
                </p>
                <h3 className="refund-subtitle">No Refunds</h3>
                <p className="refund-text">
                    We regret to inform you that we do not offer refunds for any of our services. 
                    Once a booking is confirmed and payment is processed, the amount is <strong>non-refundable</strong>. 
                    This is due to the immediate allocation of resources and scheduling upon confirmation.
                </p>
                <h3 className="refund-subtitle">Contact Us</h3>
                <p className="refund-text">
                    If you have any questions regarding our refund policy or need assistance, please 
                    reach out to our customer support team. We are here to ensure a positive experience for you.
                </p>
                <p className="refund-text">
                    Thank you for choosing <strong>ASTRACLEAN TECHNOLOGIES PVT LTD.</strong> We value your trust 
                    and look forward to serving you.
                </p>
            </div>
            <Footer />
        </>
    );
}

export default RefundPolicy;
